import React, { memo } from 'react';
import './ThemeBackground.css';

// Lightweight static gradient background (particles removed)
const ThemeBackground = () => (
  <div className="static-theme-background" aria-hidden="true" />
);

export default memo(ThemeBackground);
